import { gql, useQuery } from '@apollo/client';
import { backendNameToLabel } from '../../../utils/formatting';

export const VEHICLE_SEARCH_BY_OPTIONS = gql`
  query VehicleSearchByOptions {
    vehicleSearchByFields
  }
`;

export default function useVehicleSearchByOptions() {
  const { loading, error, data } = useQuery(VEHICLE_SEARCH_BY_OPTIONS, {
    onCompleted: () => {},
    onError: () => {}
  });

  return {
    vehicleSearchByOptions:
      data?.vehicleSearchByFields?.map(field => ({
        label: backendNameToLabel(field),
        value: field
      })) || [],
    loading,
    error
  };
}
